import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { pinWidget, unPinWidget, unPinWidgetFromBoard } from '../../../../../common/services/http/homeService';

import { IWidgetCommands } from '../../../types/IWidgetCommands';

import Icon from '../../../../ui/icon/icon';
import { parseInt } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { SWITCH_MODAL } from '../../../../../redux/types';

const WidgetCommands: React.FC<IWidgetCommands> = ({
                                                     type,
                                                     setPopup,
                                                     setPosition,
                                                     expand,
                                                     onClick,
                                                     onCollapse,
                                                     onExpand,
                                                     popup,
                                                     widget,
                                                     selectedObject,
                                                     homePage,
                                                     handleUnpin,
                                                     handleUnpinFromBoardCallback,
                                                     handlePinCallback,
                                                     unpinId,
                                                   }) => {
  const [pinned, setPinned] = useState<boolean>(false);

  const impersonate = useSelector((state: RootState) => state.impersonate.impersonate);
  const dispatch = useDispatch();

  let { boardId, investorId } = useParams();

  const handlePinWidget = () => {
    const data = {
      contentType: 'analysisContent',
      widgetId: widget.id,
      objectId: selectedObject.objectId,
      objectPath: selectedObject.objectPath,
      nodes: [],
    };
    pinWidget(parseInt(investorId), parseInt(boardId), data).then(() => {
      handlePinCallback({
        investorObjectId: parseInt(investorId),
        objectPath: selectedObject.objectPath,
        widgetId: widget.id
      })
    });
    setPinned(true);
  };

  const handleUnpinWidget = () => {
    unPinWidget(unpinId).then(() => {
      handleUnpin();
    });
    setPinned(false);
  };

  const handleUnpinFromBoard = () => {
    unPinWidgetFromBoard(parseInt(investorId), widget.id, selectedObject.objectPath).then(() => {
      handleUnpinFromBoardCallback({
        investorObjectId: parseInt(investorId),
        objectPath: selectedObject.objectPath,
        widgetId: widget.id
      });
    });
    setPinned(false);
  };

  const PinIcon = () => {
    if (homePage) {
      return <Icon onClick={impersonate ? () => dispatch({ type: SWITCH_MODAL }) : handleUnpinWidget}
                   name={'fas fa-thumbtack'}
                   className={'pointer export-icon hidden-mobile pinned-icon'} />;
    } else if (!pinned) {
      return <Icon onClick={impersonate ? () => dispatch({ type: SWITCH_MODAL }) : handlePinWidget}
                   name={'fa-regular fa-thumbtack'}
                   className={'pointer export-icon hidden-mobile'} />;
    } else {
      return <Icon onClick={impersonate ? () => dispatch({ type: SWITCH_MODAL }) : handleUnpinFromBoard}
                   name={'fas fa-thumbtack'}
                   className={'pointer export-icon hidden-mobile pinned-icon'} />;
    }
  };

  const isPinned = (pinnedArray) => {
    let objectMatch = false;
    let investorMatch = false;
    if (pinnedArray && pinnedArray.length !== 0) {
      pinnedArray.forEach((item) => {
        if (item.objectPath === selectedObject.objectPath) {
          objectMatch = true;
        }
        if (item.investorObjectId === parseInt(investorId)) {
          investorMatch = true;
        }
      });
    }
    return investorMatch && objectMatch;
  };

  useEffect(() => {
    isPinned(widget.pinned) ? setPinned(true) : setPinned(false);
  }, [selectedObject]);

  return (
    <div className={'widget-commands'}>
      <PinIcon />
      {type === 'chart' && (
        <Icon
          onClick={(e) => {
            setPopup(!popup);
            setPosition({ left: e.pageX - 117, top: e.pageY + 10 });
          }}
          name={'fa-solid fa-angle-down'}
          className={'expand-compress pointer hidden-mobile'}
        />
      )}
      {(type === 'grid' || type === 'treelist') &&
        <>
          <Icon onClick={onClick} name={'fa-regular fa-file-excel'} className={'pointer export-icon hidden-mobile'} />
        </>
      }
      {expand ? (
        <Icon onClick={onCollapse} name={'fa-regular fa-compress'} className={'expand-compress pointer'} />
      ) : (
        <Icon onClick={onExpand} name={'fa-regular fa-expand'} className={'expand-compress pointer'} />
      )}
    </div>
  );
};

export default WidgetCommands;